<template>
  <div>
    <b-table
      :data="tickets"
      :loading="loading"
      :paginated="true"
      :per-page="10"
      :striped="true"
      :hoverable="true"
    >
      <!-- ID -->
      <b-table-column field="id" label="ID" width="50" numeric v-slot="props">
        {{ props.row.id }}
      </b-table-column>

      <!-- Departamento -->
      <b-table-column
        field="departament.name"
        label="Departamento"
        v-slot="props"
      >
        {{ props.row.departament?.name || "Sin departamento" }}
      </b-table-column>

      <!-- Fecha -->
      <b-table-column field="created_at" label="Fecha" v-slot="props">
        {{ props.row.created_at }}
      </b-table-column>

      <!-- Acciones -->
      <b-table-column label="Acciones" v-slot="props">
        <b-button
          type="is-info"
          size="is-small"
          @click="$router.push(`/consultas/id/${props.row.id}`)"
        >
          Ver consulta
        </b-button>
      </b-table-column>

      <!-- Sin datos -->
      <template #empty>
        <div class="has-text-centered p-4">
          <p>No se encontraron consultas para este contacto.</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ContactTickets",

  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      tickets: [],
      loading: false,
    };
  },

  watch: {
    contactId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchTickets(newVal);
        }
      },
    },
  },

  methods: {
    async fetchTickets(contactId) {
      this.loading = true;
      try {
        const response = await this.$repositories.tickets.ticketsByContact(
          contactId
        );
        this.tickets = response.data.tickets || [];
      } catch (error) {
        console.error("Error al cargar tickets:", error);
        this.tickets = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
